(()=>{const reveal=()=>{const map=document.querySelector('#bazaar-map');if(map&&map.querySelector('.rr-imap')){map.scrollIntoView({behavior:'smooth',block:'start'});return true;}return false;};document.addEventListener('click',(event)=>{const link=event.target.closest('a[href$="#bazaar-map"]');if(!link)return;event.preventDefault();let tries=0;const wait=setInterval(()=>{tries+=1;if(reveal()||tries>=50)clearInterval(wait);},100);});})();
(function(init){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{once:true});}else{init();}})(function(){
  const preview='?preview_theme_id=189205938489';
  const routes={
    '#guardian':'/collections/the-great-house-of-guardian'+preview,
    '#foragers':'/collections/the-great-house-of-foragers'+preview,
    '#soulbloom':'/collections/the-great-house-of-soulbloom'+preview,
    '#loomsong':'/collections/the-great-house-of-loomsong'+preview,
    '#hammerfall':'/collections/the-great-house-of-hammerfall'+preview,
    '#embermould':'/collections/the-great-house-of-embermould'+preview
  };

  document.querySelectorAll('a[href]').forEach(function(a){
    const href=a.getAttribute('href');
    if(routes[href]) a.setAttribute('href',routes[href]);
    if(href==='#travelers-landing') a.setAttribute('href','/pages/travelers-landing'+preview);
    if(href==='#root-rukkus') a.setAttribute('href','/pages/root-and-ruckus'+preview);
    if(href==='/pages/travelers-landing') a.setAttribute('href','/pages/travelers-landing'+preview);
    if(href==='/pages/root-and-ruckus') a.setAttribute('href','/pages/root-and-ruckus'+preview);
    if(href==='/pages/booksellers-stall') a.setAttribute('href','/pages/booksellers-stall'+preview);
    if(href && href.indexOf('/collections/the-great-house-of-')===0 && href.indexOf('preview_theme_id')===-1) a.setAttribute('href',href+preview);
    if(href && href.indexOf('/?view=root-revel#')===0){const hash=href.split('#')[1];a.setAttribute('href','/'+preview+'#'+hash);}
    if(href==='/' && a.closest('.tl-closing')) a.setAttribute('href','/'+preview);
  });

  const landingHero=document.querySelector('.tl-hero');
  if(landingHero && !document.querySelector('.tl-arrival-scene')){
    const scene=document.createElement('div');
    scene.className='tl-arrival-scene';
    scene.innerHTML='<div class="tl-arrival-frame"><img src="https://cdn.shopify.com/s/files/1/0881/9382/7129/files/Traveler_s_Landing.png?v=1787088743" alt="Traveler’s Landing beneath the World Tree"><div class="tl-arrival-caption"><span>Traveler’s Landing</span><small>The first threshold beneath the World Tree</small></div></div>';
    landingHero.insertAdjacentElement('afterend',scene);
  }

  const hammerHero=document.querySelector('.hammerfall-hero');
  const hammerNav=document.querySelector('.rr-pathbar');
  if(hammerHero && hammerNav){hammerHero.insertAdjacentElement('afterend',hammerNav);}

  const mapImage='https://cdn.shopify.com/s/files/1/0881/9382/7129/files/Root_Revel_interactive_map.png?v=1787092425';
  const destinations=[
    {key:'worldtree',label:'World Tree',href:'/'+preview+'#world-tree'},
    {key:'guardian',label:'The Guardians',href:'/collections/the-great-house-of-guardian'+preview},
    {key:'foragers',label:'The Foragers',href:'/collections/the-great-house-of-foragers'+preview},
    {key:'soulbloom',label:'Soulbloom',href:'/collections/the-great-house-of-soulbloom'+preview},
    {key:'loomsong',label:'Loomsong',href:'/collections/the-great-house-of-loomsong'+preview},
    {key:'hammerfall',label:'Hammerfall',href:'/collections/the-great-house-of-hammerfall'+preview},
    {key:'embermould',label:'Embermould',href:'/collections/the-great-house-of-embermould'+preview},
    {key:'bookseller',label:'The Bookseller’s Stall',href:'/pages/booksellers-stall'+preview},
    {key:'ruckus',label:'Root & Ruckus',href:'/pages/root-and-ruckus'+preview},
    {key:'lantern',label:'Lantern Road',href:'/pages/root-and-ruckus'+preview}
  ];

  function interactiveMapMarkup(context){
    const hotspots=destinations.map(function(d){
      return '<a class="rr-hotspot rr-hotspot--'+d.key+'" href="'+d.href+'" aria-label="Travel to '+d.label+'" data-label="'+d.label+'"><span class="rr-sr-only">'+d.label+'</span></a>';
    }).join('');
    const key=destinations.map(function(d){return '<a href="'+d.href+'">'+d.label+'</a>';}).join('');
    return '<div class="rr-imap rr-imap--'+context+'">'+
      '<div class="rr-imap__frame"><div class="rr-imap__canvas">'+
      '<img class="rr-imap__image" src="'+mapImage+'" alt="Illustrated map of Root & Revel beneath the World Tree, showing the Great Houses, Bookseller’s Stall, Root & Ruckus and Lantern Road" width="1536" height="1024">'+hotspots+
      '</div></div><div class="rr-map-key" aria-label="Root and Revel destinations">'+key+'</div><p class="rr-imap__hint">Choose a painted landmark to travel there.</p></div>';
  }

  const choose=document.querySelector('.tl-paths#choose-your-path');
  if(choose){choose.innerHTML='<div class="tl-heading"><p class="tl-eyebrow">Choose a path—or don’t</p><h2>Where does your curiosity lead?</h2><p>The map itself is your guide. Choose any painted landmark and follow it into the Realm.</p></div>'+interactiveMapMarkup('landing');}

  const mapSection=document.querySelector('.rr-map#bazaar-map');
  if(mapSection){mapSection.innerHTML='<div class="rr-map__head"><p class="rr-eyebrow">The paths beneath the boughs</p><h2>Choose a Path</h2><p>Every painted landmark is a doorway. Follow a House, a bookstall, or the lanterns west.</p></div>'+interactiveMapMarkup('bazaar');}
});
